export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_PASSWORD = 'SET_PASSWORD';
export const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR';
export const SET_PASSWORD_ERROR = 'SET_PASSWORD_ERROR';
